<div class="vipinfo-contents-wrapper">
  <div class="selector-div-wrapper">
    <p><small>Is Link</small></p>
    <div class="form-check form-switch">
      <input class="input-switch-sm form-check-input" type="checkbox" role="switch" id="vipinfo-switch" #isLink />
    </div>
  </div>
  <div class="d-flex justify-content-center">
    <button class="btn btn-default my-3 create-btn" (click)="onCreateButton()">Create</button>
  </div>
  <ul *ngIf="vipButtons.length > 0" style="list-style-type: none">
    <li *ngFor="let item of vipButtons; index as i" class="py-2">
      <div class="filter-content-wrapper">
        <span style="font-weight: bold">[{{ item.type.split('')[0].toUpperCase() }}]&nbsp;</span>
        <span class="flex-grow-1">
          -
          {{
          item.config.buttonTitle
          ? item.config.buttonTitle
          : item.type === 'link'
          ? 'Link ' + (i + 1)
          : 'Button ' + (i + 1)
          }}</span>
        <button (click)="editItem(item)" class="btn-action-icon" title="Editar">
          <i id="edit"></i>
        </button>
      </div>
    </li>
  </ul>
</div>